/**
 * Validation rules used in validation.js
 */

const validationRules = (() => {
  let _matching = {};

  /**
   * Set rule-logic matching
   */
  const init = () => {
    _matching = {
      required: required,
      name: name,
      email: email,
      phone: phone,
      samePhone: samePhone,
      length: length,
      optionalReply: optionalReply,
    };
  };


  /**
   * Return matching rule
   * @param rule
   */
  const returnValidationRule = (rule) => {
    //TODO: add some element check/ parsing
    rule = rule.trim();
    return _matching[rule];
  };

  /**
   * required field validation test. Sometimes it can be a boolean value
   *
   * @param {String|Boolean|Array} value
   * @returns {boolean}
   */
  const required = (value, type) => {
    if (type !== "checkbox" && type !== "file") {
      value = value.replace(/\s+/g, "");
    }

    if (!value) {
      return {
        error: true,
        msg: "required",
      };
    }
    return { error: false };
  };
  /**
   * Name/surname validation test
   *
   * @param {String} value
   * @returns {Boolean}
   */
  const name = (value) => {
    return /^[a-zżźćńółęąś\s\-]+$/i.test(value)
      ? { error: false }
      : {
        error: true,
        msg: "Pole może zawierać tylko litery",
      };
  };

  const optionalReply = (value) => {
    const fields = document.querySelectorAll('[data-optional-required]')

    const results = Array.from(fields).map(field => {
      if (field.type === 'textarea') {
        return field.value !== ''
      } else {
        return field.files.length > 0
      }
    })

    if(results.some(e => e)){
      fields.forEach(element => {
        const container = element.parentNode;
        container.classList.remove("error");
      })

      return ({ error: false })
    }

    return {
      error: true,
      msg: "",
    }
  }


  const email = (value) => {
    let polishLetters = /[ąĄćĆęĘłŁńŃóÓśŚźŹżŻ]/;
    const errorMessage = `
                <span class="tip">Podany e-mail jest nieprawidłowy</span>
    `

    if (value.indexOf("@") > -1) {
      let name = value.split("@")[0];

      if (name.length > 64 || value.match(polishLetters) !== null || !value) {
        return {
          error: true,
          msg: errorMessage,
        };
      }
    }

    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    )
      ? { error: false }
      : {
        error: true,
        msg: errorMessage,
      };
  };

  const phone = (value) => {
    if (!!value === false) {

      return {
        error: true,
        msg: "Podany numer telefonu jest nieprawidłowy"
      };
    }

    return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(value) ? {error: false} : {
      error: true,
      msg: "Podany numer telefonu jest nieprawidłowy"
    };
  };

  const samePhone = (input) => {
    let baseContainer = document.querySelector('[data-validation-rules="required, phone, samePhone"]').parentNode.previousElementSibling;

    if (baseContainer) {
      let basePhone = baseContainer.querySelector('[type="phone"]');
  
      return basePhone.value !== input
          ? { error: true, msg: "Podane numery telefonu nie są identyczne" }
          : { error: false };
    }

  };


  const length = (value) => {
    // let minLength = 200;
    let maxLength = 500;

    if (value.length > maxLength) {
      return {
        error: true,
        msg: `Maksymalna długość tekstu to ${maxLength} znaków`,
      };
    }
    // else if (value.length < minLength) {
    //   return {
    //     error: true,
    //     msg: `Tekst jest któtszy niż ${minLength} znaków`,
    //   };
    // }
    return { error: false };
  };

  return {
    init: init,
    returnValidationRule: returnValidationRule,
  };
})();

export { validationRules };
